import DOMPurify from 'dompurify';

const ALLOWED_IFRAME_HOSTS = new Set([
  'www.youtube.com',
  'www.youtube-nocookie.com',
  'player.vimeo.com'
]);

const isAllowedIframeSrc = (src) => {
  if (!src) {
    return false;
  }

  try {
    const baseUrl = typeof window !== 'undefined' ? window.location.href : 'https://eladoreruffles.com';
    const url = new URL(src, baseUrl);
    return url.protocol === 'https:' && ALLOWED_IFRAME_HOSTS.has(url.hostname);
  } catch (error) {
    return false;
  }
};

DOMPurify.addHook('uponSanitizeElement', (node, data) => {
  if (data.tagName !== 'iframe') {
    return;
  }

  if (!isAllowedIframeSrc(node.getAttribute('src'))) {
    node.parentNode?.removeChild(node);
  }
});

export function sanitizeHtml(dirty) {
  return DOMPurify.sanitize(dirty || '', {
    USE_PROFILES: { html: true },
    ADD_TAGS: ['iframe'],
    ADD_ATTR: [
      'allow',
      'allowfullscreen',
      'frameborder',
      'height',
      'loading',
      'referrerpolicy',
      'src',
      'title',
      'width'
    ],
  });
}
